import { useQueries } from "@tanstack/react-query";

import CampaignService from "services/Campaign";
import EntityService from "services/Entity";

const PRESET_LOADERS = [
  ["entity", "entityId", id => EntityService.getEntity(id)],
  ["campaign", "campaignId", id => CampaignService.getCampaign(id)],
];

/**
 * The records a create preset points at. The page names them, and the form
 * labels the disabled entity picker with the preset entity's name.
 */
export const usePresetRecords = (preset = {}) =>
  useQueries({
    queries: PRESET_LOADERS.map(([name, key, load]) => ({
      queryKey: ["contact-preset", name, preset[key] ?? null],
      queryFn: () => load(preset[key]),
      enabled: preset[key] != null,
    })),
    // React Query keeps the combined result referentially stable while the
    // query results are unchanged.
    combine: results => ({
      records: Object.fromEntries(
        PRESET_LOADERS.map(([name], index) => [name, results[index].data])
      ),
      isPending: results.some(
        (result, index) =>
          preset[PRESET_LOADERS[index][1]] != null && result.isPending
      ),
      isError: results.some(result => result.isError),
    }),
  });
